import type { CheckinQuestion, CheckinAnswerValue } from '../../../../types/checkin';
import { EmojiScaleQuestion } from './EmojiScaleQuestion';
import { TextListQuestion } from './TextListQuestion';
import { YesNoQuestion } from './YesNoQuestion';
import { TextQuestion } from './TextQuestion';
import { TextareaQuestion } from './TextareaQuestion';
import { ScaleQuestion } from './ScaleQuestion';

interface QuestionRouterProps {
  question: CheckinQuestion;
  value: CheckinAnswerValue | undefined;
  onChange: (value: CheckinAnswerValue) => void;
}

export function QuestionRouter({
  question,
  value,
  onChange,
}: QuestionRouterProps) {
  switch (question.type) {
    case 'emoji-scale':
      return (
        <EmojiScaleQuestion
          question={question}
          value={value as number | undefined}
          onChange={onChange}
        />
      );

    case 'text-list':
      return (
        <TextListQuestion
          question={question}
          value={value as string[] | undefined}
          onChange={onChange}
        />
      );

    case 'yes-no':
      return (
        <YesNoQuestion
          question={question}
          value={value as boolean | undefined}
          onChange={onChange}
        />
      );

    case 'text':
      return (
        <TextQuestion
          question={question}
          value={value as string | undefined}
          onChange={onChange}
        />
      );

    case 'textarea':
      return (
        <TextareaQuestion
          question={question}
          value={value as string | undefined}
          onChange={onChange}
        />
      );

    case 'scale':
      return (
        <ScaleQuestion
          question={question}
          value={value as number | undefined}
          onChange={onChange}
        />
      );

    default:
      return (
        <div className="text-red-500">
          Unknown question type: {(question as any).type}
        </div>
      );
  }
}
